module.exports = __webpack_public_path__ + "static/img/layout-img-main@m.3e1b560.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/layout-img-main@m.png
// module id = nztU
// module chunks = 0